import { PAGE_URLS } from "src/configs/pages-urls";
import { convertFrameworkRoute } from "src/utils/routes";

export default [
	{
		path: PAGE_URLS.publicLink.path,
		lazy: () =>
			import(
				"src/module--trackings/pages/tracking.page/shared-tracking.page"
			).then(convertFrameworkRoute),
	},
];
